module.exports = __webpack_public_path__ + "0419a44cc3b363bb8f89464a19ec01ee.pdf";